<template>
<div class="page">
    <div class="loading-screen" v-if="status=='LOADING'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading questions…</span>
        </div>
    </div>

    <div v-if="status=='LOADED'">
        <header class="topbar">
            <div class="topbar__inner">
                <a href="/assesments" class="btn btn--ghost btn--sm">← Back</a>
                <span class="brand" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{assesment.name}}</span>
                <div class="topbar__user" v-if="assesment.name!='Sample Exam'">
                    <span class="status-pill status-pill--live">
                        <span class="countdown">{{(getRemainingHours())<10?'0'+(getRemainingHours()):(getRemainingHours())}}:{{(getRemainingMinutes())<10?'0'+(getRemainingMinutes()-1):(getRemainingMinutes()-1)}}:{{(60-currentTimeSeconds)<10?'0'+(60-currentTimeSeconds):(60-currentTimeSeconds)}}</span>
                    </span>
                </div>
                <div class="topbar__user" v-else>
                    <span class="chip">sample — no timer</span>
                </div>
            </div>
        </header>

        <div class="container">
            <div class="page-head rise">
                <h1>Questions</h1>
                <p>Pick a question to open the code editor. Your progress is saved per submission.</p>
            </div>

            <div v-for="(question, index) in questions" :key="question._id"
                 class="glass card card--hover mb-3 rise" :class="`rise-${Math.min(index+1,4)}`">
                <div class="flex justify-between items-center flex-wrap gap-3">
                    <div style="min-width:0;flex:1">
                        <span class="card__meta">question {{String(index+1).padStart(2,'0')}}</span>
                        <h2 class="card__title mt-2">
                            {{question.name}}
                            <span class="badge badge--easy" v-if="question.difficulty=='easy'">easy</span>
                            <span class="badge badge--medium" v-else-if="question.difficulty=='medium'">medium</span>
                            <span class="badge badge--hard" v-else>hard</span>
                        </h2>
                        <p class="text-dim mt-2" style="font-size:0.92rem;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">{{question.statement}}</p>
                    </div>
                    <button class="btn btn--primary btn--sm" @click.prevent="solveQuestion(question._id)">Solve →</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '@/router';
import Vue from 'vue';
import {getQuestions} from '../services/questions'
export default {
    name: "QuestionsPage",
    data() {
        return {
            status: "LOADING",
            error: "",
            assesment: {},
            currentTimeHour: new Date().getHours(),
            currentTimeMinutes: new Date().getMinutes(),
            currentTimeSeconds: new Date().getSeconds(),
            questions: this.getAllQuestions(),
            assesmentId: ''
        };
    },
    methods: {
        async getAllQuestions() {
            this.assesmentId = router.history.current.params.id;
            try {
                const response = await getQuestions(this.assesmentId);
                this.assesment = response.data;
                this.questions = response.data.questions;
                this.status = "LOADED";
            }
            catch (error) {
                this.status = "ERROR";
                this.error = error.message;
            }
        },
        solveQuestion(questionId) {
            this.$router.push({
                path : `/${router.history.current.params.id}/questions/${questionId}`
            })
        },
        compareTime() {
            if (this.assesment.name == 'Sample Exam') return;
            if(this.currentTimeHour > this.assesment.endTime.hours )
                this.$router.push({path : '/assesments'});
            else if(this.currentTimeHour == this.assesment.endTime.hours) {
                if(this.currentTimeMinutes >= this.assesment.endTime.minutes)
                    {

                        this.$router.push({path : '/assesments'});
                        Vue.$toast.error('Time Expired');
                    }

            }
        },
        getRemainingMinutes() {
            let minutes = this.assesment.endTime.minutes-this.currentTimeMinutes;
            return minutes>0?minutes:60+minutes;
        },
        getRemainingHours() {
            let minutes = this.assesment.endTime.minutes-this.currentTimeMinutes;
            return minutes>0?this.assesment.endTime.hours-this.currentTimeHour:this.assesment.endTime.hours-this.currentTimeHour-1;
        }
    },
     created () {
         setInterval(() => {
            this.currentTimeHour = new Date().getHours();
            this.currentTimeMinutes = new Date().getMinutes();
            this.currentTimeSeconds = new Date().getSeconds();
            if (this.$router.currentRoute.path != '/assesments')
            this.compareTime();
        },1000)
    }
}
</script>
